import { useEffect, useState } from 'react'
import { Header } from '../users/components/Header'
import { CreateCompanyDrawer } from './components/CreateCompanyDrawer';
import CompaniesTable from './components/CompaniesTable';
import { useGetAllCompanies } from '../users/hooks/useGetAllCompanies';
import { useDispatch, useSelector } from 'react-redux';
import { loadCompanies } from './slices/companiesSlice';
import { RootState } from '../../app/store';
import { ICompany } from '../../api/companies/types';
import { Input } from '@/components/UI/Input/Input';

export const Companies = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [companyToEdit, setCompanyToEdit] = useState<ICompany | undefined>();
  const [searchTerm, setSearchTerm] = useState('');
  const { data: companiesData, isLoading } = useGetAllCompanies();
  const companies = useSelector((state: RootState) => state.companies.companies);
  const dispatch = useDispatch();

  const handleOpenDrawer = (): void => {
    setCompanyToEdit(undefined);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = (): void => {
    setDrawerOpen(false);
    setCompanyToEdit(undefined);
  };

  const handleEditCompany = (company: ICompany): void => {
    setCompanyToEdit(company);
    setDrawerOpen(true);
  };

  const filteredCompanies = companies?.filter(company => 
    company.nameCompany.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    if (!isLoading && companiesData) {
      dispatch(loadCompanies(companiesData));
    }

    // Cleanup function
    return () => {
      dispatch(loadCompanies({ success: false, message: '', data: [] }));
    };
  }, [companiesData, isLoading, dispatch]);

  return (
    <>
      <Header
        saveNewItem={handleOpenDrawer}
        title="list_menu.list_menu_companies"
        buttonText="companies_module.module_button_create"
      />
      <div style={{ padding: '0 2rem', marginBottom: '1rem' }}>
        <Input
          type="text"
          label="Buscar"
          placeholder="Buscar compañía..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          icon="more"
        />
      </div>
      <CreateCompanyDrawer
        isOpen={isDrawerOpen}
        onClose={handleCloseDrawer}
        companyToEdit={companyToEdit}
      />
      <CompaniesTable
        companies={filteredCompanies}
        onEditCompany={handleEditCompany}
      />
    </>
  )
}
